import { lazy, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

export interface PDFViewerProps {
  fileUrl: string;
  /** Titulo accesible del iframe de respaldo. */
  title: string;
  /** Sin permiso de descarga se bloquea el clic derecho y, si hay que caer al iframe, se oculta su barra. */
  allowDownload: boolean;
}

// Unico punto que el barrel de ui expone: react-pdf solo se importa dentro de
// PDFViewerContent, asi pdf.js queda en su propio chunk.
const loadPDFViewerContent = () => import('./PDFViewerContent');
const PDFViewerContent = lazy(loadPDFViewerContent);

/** Descarga el chunk de pdf.js antes de abrir el visor (p. ej. en onMouseEnter). */
export const preloadPDFViewer = loadPDFViewerContent;

/**
 * Visor de PDF con paginacion y zoom. Ocupa `flex: 1`: el padre debe ser un
 * contenedor flex en columna con altura definida.
 */
export function PDFViewer(props: PDFViewerProps) {
  return (
    <Suspense fallback={<CircularProgress sx={{ m: 'auto' }} />}>
      {/* key: reinicia pagina, zoom y fallback al cambiar de documento. */}
      <PDFViewerContent key={props.fileUrl} {...props} />
    </Suspense>
  );
}
